import React from 'react';

import { usePortfolioComponentKeys } from 'hooks/usePortfolioComponentKeys';

import { TooltipPosition } from 'components/common/CustomizedTooltip/customizedTooltip.enums';
import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';

import { IComponentKey } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';
import { CustomizedTooltip } from 'components/common';

import classes from './SelectedProjectContractView.module.scss';

const PORTFOLIO = 'Portfolio';

export const SelectedProjectContractView = ({
    projectName,
    contractName,
    latestVersionTitle,
    compareVersionTitle,
    componentKey,
}) => {
    const PORTFOLIO_COMPONENT_KEYS = usePortfolioComponentKeys();
    const isPortfolioWidget = PORTFOLIO_COMPONENT_KEYS.includes(componentKey as IComponentKey);

    if (isPortfolioWidget) {
        return (
            <div className={classes.selectedProjectContractView}>
                <div className={classes.projectAndContract}>
                    <div>
                        <span className={classes.project}>{PORTFOLIO}</span>
                    </div>
                </div>
            </div>
        );
    }
    if (!projectName && !contractName) {
        return null;
    }
    return (
        <div className={classes.selectedProjectContractView}>
            <CustomizedTooltip
                tooltipPosition={TooltipPosition.Top}
                tooltipContent={
                    <div className={classes.compareVersionsTooltipWrapper}>
                        <div className={classes.versionRow}>
                            <div className={classes.versionTitle}>Latest version:</div>
                            <div className={classes.versionValue}>{latestVersionTitle}</div>
                        </div>
                        <div className={classes.versionRow}>
                            <div className={classes.versionTitle}>Compare to:</div>
                            <div className={classes.versionValue}>{compareVersionTitle}</div>
                        </div>
                    </div>
                }
                triggerElement={
                    <div className={classes.projectAndContract}>
                        <div>
                            <span className={classes.project}>{projectName}</span>
                            <span className={classes.separator}>
                                <MuiIcon icon={'chevron_right'} fontSize={'15px'} color={'inherit'} />
                            </span>
                            <span className={classes.contract}>{contractName}</span>
                        </div>
                    </div>
                }
            />
        </div>
    );
};
